"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
var _capitalizeFirst = _interopRequireDefault(require("./capitalizeFirst"));
var _isNotString = _interopRequireDefault(require("./helpers/isNotString"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * convert a string to pascal casing and treat - and _ as word delimiters
 *
 * @example
 * pascalize('some_snake_case') => 'SomeSnakeCase'
 * pascalize('some-pipe-case') => 'SomePipeCase'
 * pascalize('some word') => 'SomeWord'
 * pascalize('someCamelCase') => 'SomeCamelCase'
 */
var pascalize = function pascalize(str) {
  if ((0, _isNotString.default)(str)) return '';
  return str.split(/[-_\s]/).map(_capitalizeFirst.default) // TODO: is this very clever or a bug?
  .join('');
};
var _default = exports.default = pascalize;